/* eslint-disable @typescript-eslint/naming-convention*/
import { TWResponse } from '../common/response.models';

export class ModelVersion {
  id: string;
  version: string;
  release_date: string;
  release_notes: string;
  compatibility?: string;
  electric_available: boolean;
  thermal_available: boolean;
  aging_available: boolean;
  datasheet_location: string | null;
  model_data_location: string | null;

  soc_min: number;
  soc_max: number;

  soh_min: number;
  soh_max: number;

  voltage_min: number;
  voltage_max: number;

  temperature_min: number;
  temperature_max: number;

  discharge_max: number;
  charge_max: number;
}

export class LicenseInfo {
  license_type?: string;
  allowed_activations?: number;
  total_activations?: number;
  license_key?: string;
  license_expiry?: string;
}

export class ModelLibraryCell {
  id: string;

  nominal_capacity: number;
  designation: string;
  manufacturer: string;

  height?: number;
  weight?: number;
  format?: string;
  model_versions?: ModelVersion[];

  chemistry?: string;
  nominal_voltage?: number;

  discharge_max?: number;
  charge_max?: number;

  // License info also acts as "is purchased" indicator -> if there is no license info, the item is not available to the user
  license_info?: LicenseInfo;

  is_proprietary?: boolean;

  diameter?: number;
  length?: number;
  width?: number;

  label?: string;
}

export class ModelLibraryResponse extends TWResponse {
  data: ModelLibraryCell[];
}

export class DownloadLinkResponse extends TWResponse {
  data: string;
}
